import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Modal } from 'antd';

function ForgotPasswordInfo({ email, onClick }) {
  const { t } = useTranslation();

  const onSendAgain = () => {
    onClick();
    Modal.success({
      title: t('letter-sent-successfully'),
      centered: true,
      content: (
        <p className="forgot-password-page__modal-text">
          {t('check-email-alert')}
        </p>
      ),
      okText: t('close'),
    });
  };

  return (
    <div className="forgot-password-page__info">
      <p className="forgot-password-page__description">
        {t('restore-link')} <strong>{email}</strong>.
      </p>
      <div className="forgot-password-page__send-again">
        <Button onClick={onSendAgain} type="link">
          {t('send-letter-again')}
        </Button>
      </div>
    </div>
  );
}

export default ForgotPasswordInfo;
